import { useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { LoadingButton } from "src/components/blocks/LoadingButton.js";
import { AuthContext } from "src/utils/AuthContext.js";
import { getPageRoute } from "src/services/Config.js";
import { useFeatureAccess } from "src/utils/FeatureAccessContext.js";
import { handleUpgrade } from "src/utils/Utils.js";
import { useSimplePayment } from "src/utils/useSimplePayment.js";

export const UpgradeConsumerButton = ({
  sx,
  children,
  successUrl = null,
  state,
  ...props
}) => {
  const user = useContext(AuthContext).user;
  const [searchParams] = useSearchParams();
  const isLifeTimeMember = user?.lifetimeMember;
  const navigate = useNavigate();
  const { requestFeatureAccess } = useFeatureAccess();
  const { shouldTrySimplePayment } = useSimplePayment({
    onSuccess: () => {},
  });

  const handleGoHome = () => {
    navigate(getPageRoute("home", "HOME"));
  };
  const handleClick = async () => {
    if (isLifeTimeMember) {
      handleGoHome();
      return;
    }

    const navigateToSuccess = () => {
      if (successUrl) {
        // Add success param to URL
        const successUrlSearchParams = new URLSearchParams(
          successUrl.split("?")?.[1] ?? ""
        );
        successUrlSearchParams.set("success", "true");
        const finalSuccessUrl = `${
          successUrl.split("?")[0]
        }?${successUrlSearchParams.toString()}`;

        navigate(finalSuccessUrl, { state });
      }
    };

    const featureKey = "STANDARD_UPGRADE";

    if (!shouldTrySimplePayment(featureKey)) {
      // Use generic upgrade flow - redirect to upgrade page
      await handleUpgrade({
        user,
        searchParams,
        navigate,
        successUrl,
        state,
      });
      return;
    }

    // we are sure that it doesn't has access however we use it to handle the simple payment flow
    await requestFeatureAccess(featureKey, {
      currentPath: window.location.pathname + window.location.search,
      action: navigateToSuccess,
      continueText: "Continue",
    });
  };

  return (
    <LoadingButton
      size="grown"
      variant="contained"
      color="primary"
      onClick={handleClick}
      sx={{ height: "auto", width: "100%", ...sx }}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};
